const STATE = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  LOADED: 'LOADED'
};

let state = STATE.IDLE;
let listeners = [];
let isReady = false;

function addYoutubeScriptTag(callback) {
  const scriptTag = document.createElement('script');
  const firstScriptTag = document.getElementsByTagName('script')[0];

  scriptTag.src = 'https://www.youtube.com/iframe_api';

  window.onYouTubeIframeAPIReady = function () {
    window.onYouTubeIframeAPIReady = null;

    callback();
  };

  firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
}

function load() {
  if (state !== STATE.IDLE) {
    return;
  }

  state = STATE.LOADING;

  addYoutubeScriptTag(function () {
    state = STATE.LOADED;

    listeners.forEach(function (listener) {
      listener();
    });

    listeners = null;
  })
}

export function loadYoutubeApi() {
  if (isReady) {
    return;
  }

  isReady = true;

  if (listeners && (listeners.length > 0)) {
    load();
  }
}

export function onYoutubeReady(callback) {
  switch (state) {
    case STATE.IDLE:
    case STATE.LOADING:
      listeners.push(callback);

      if (isReady) {
        load();
      }

      break;

    case STATE.LOADED:
      callback();

      break;
    default:
  }
}



// WEBPACK FOOTER //
// ./src/youtubeApi.js